export default function APLink({children, ...others} : any) {
  return (
    <button className="link-button" {...others}>
      {children}
    </button>
  );
}
